export enum ButtonVariants {
  Filled = 'filled',
  Outlined = 'outlined'
}
